/**
 * PDF出力関連の定数
 * ReportAndDraft.tsx の JSX（id属性）と generatePdf.ts（getElementById）の両方で使用
 */

// 数量、金額の丸め：値
export const DIVISOR_VALUE: number = 1000;
// 数量、金額の丸め：単位
export const DIVISOR_STR: string = "千";

// 【販売数量・販売単価】PartNoテーブルIDの接頭辞
export const QUANTITY_PRICE_PARTNO_TABLE_PREFIX = "quantity-and-price-partNo-";

// 【販売数量・販売単価】金型(プロジェクト単位)テーブルID
export const QUANTITY_PRICE_MOLD_TABLE_PREFIX = "quantity-and-price-mold-0";

// 【販売数量・販売単価】開発費(プロジェクト単位)テーブルID
export const QUANTITY_PRICE_DEV_TABLE_PREFIX = "quantity-and-price-dev-0";

// 【販売数量・販売単価】設備費(プロジェクト単位)テーブルID
export const QUANTITY_PRICE_EQUIPMENT_TABLE_PREFIX = "quantity-and-price-equipment-0";

// 【販売数量・販売単価】プロジェクト合計テーブルID
export const QUANTITY_PRICE_PROJECT_TOTAL_TABLE_PREFIX = "quantity-and-price-total-0";

// 【P&L】PartNoテーブルIDの接頭辞
export const PROFIT_AND_LOSS_PARTNO_TABLE_PREFIX = "profit-and-loss-partNo-";

// 【P&L】PartNoテーブルIDの接頭辞
export const PROFIT_AND_LOSS_PARTNO_OUTSOURC_TABLE_PREFIX = "profit-and-loss-partNo-outsourc-";

// 【P&L】PartNoテーブルIDの接頭辞
export const PROFIT_AND_LOSS_PARTNO_INHOUSE_TABLE_PREFIX = "profit-and-loss-partNo-inhouse-";

// 【P&L】金型(プロジェクト単位)テーブルID
export const PROFIT_AND_LOSS_MOLD_TABLE_PREFIX = "profit-and-loss-mold-0";

// 【P&L】開発費(プロジェクト単位)テーブルID
export const PROFIT_AND_LOSS_DEV_TABLE_PREFIX = "profit-and-loss-dev-0";

// 【P&L】設備費(プロジェクト単位)テーブルID
export const PROFIT_AND_LOSS_EQUIPMENT_TABLE_PREFIX = "profit-and-loss-equipment-0";

// 【P&L】年度別総計のテーブルID
export const PROFIT_AND_LOSS_GRAND_TOTAL_TABLE_PREFIX = "profit-and-loss-grand-total-0";

// 【P&L】DCFのテーブルID
export const PROFIT_AND_LOSS_DCF_TABLE_PREFIX = "profit-and-loss-dcf-0";

// 【P&L】回収期間のテーブルID
export const PROFIT_AND_LOSS_PAYBACK_PERIOD_TABLE_PREFIX = "profit-and-loss-payback-period-0";

// 【P&L】増分キャッシュフローのテーブルID
export const PROFIT_AND_LOSS_COLLECT_SIMULATION_TABLE_PREFIX = "profit-and-loss-collect-simulation-0";

// 【P&L】更新による改善効果のテーブルID（更新投資の場合のみ）
export const UPDATE_IMPROVEMENT_EFFECT_TABLE_PREFIX = "update-improvement-effect-0";
// 【P&L】更新による改善効果の各プロセスのIDプレフィックス（更新投資の場合のみ）
export const UPDATE_IMPROVEMENT_EFFECT_PROCESS_ITEM_PREFIX = "update-improvement-effect-process-";
// 【P&L】更新による改善効果（指標）の各プロセスのIDプレフィックス（更新投資の場合のみ）
export const UPDATE_IMPROVEMENT_INDICATOR_PROCESS_PREFIX = "update-improvement-indicator-process-";
// 【P&L】更新による改善効果（費用）の各プロセスのIDプレフィックス（更新投資の場合のみ）
export const UPDATE_IMPROVEMENT_COST_PROCESS_PREFIX = "update-improvement-cost-process-";
// 【P&L】更新による改善効果の全工程合計のID（更新投資の場合のみ）
export const UPDATE_IMPROVEMENT_EFFECT_TOTAL_ID = "update-improvement-effect-total";

// 【P&L】合理化投資 年度別損益（合理化前）のID
export const RATIONALIZATION_BEFORE_PROFIT_LOSS_ID = "rationalization-before-profit-loss";
// 【P&L】合理化投資 年度別損益（合理化後）のID
export const RATIONALIZATION_AFTER_PROFIT_LOSS_ID = "rationalization-after-profit-loss";
// 【P&L】合理化による改善効果（指標）の各プロセスのIDプレフィックス（合理化投資の場合のみ）
export const RATIONALIZATION_IMPROVEMENT_INDICATOR_PROCESS_PREFIX = "rationalization-improvement-indicator-process-";
// 【P&L】合理化による改善効果（費用）の各プロセスのIDプレフィックス（合理化投資の場合のみ）
export const RATIONALIZATION_IMPROVEMENT_COST_PROCESS_PREFIX = "rationalization-improvement-cost-process-";
// 【P&L】改善効果の合計のID（合理化投資の場合のみ）
export const RATIONALIZATION_IMPROVEMENT_EFFECT_TOTAL_ID = "rationalization-improvement-effect-total";

// 【設備投資】更新前後サマリーデータ一覧のID（更新投資の場合のみ）
export const UPDATE_SUMMARY_DATA_LIST_PREFIX = "update-summary-data-list-0";
// 【設備投資】更新前後サマリーデータ一覧の各プロセスのIDプレフィックス
export const UPDATE_SUMMARY_ITEM_PREFIX = "update-summary-item-";

// 【Simulation】生産能力（プロセス）の各プロセスのIDプレフィックス（更新投資の場合のみ）
export const PRODUCTION_CAPACITY_PROCESS_ITEM_PREFIX = "production-capacity-process-item-";
// 【Simulation】合理化前後サマリーチャートの各プロセスのIDプレフィックス（合理化投資の場合のみ）
export const RATIONALIZATION_SUMMARY_CHART_ITEM_PREFIX = "rationalization-summary-chart-item-";
// PDF出力時: 1ページあたりの合理化前後サマリーチャート表示上限数
export const RATIONALIZATION_SUMMARY_CHARTS_PER_PAGE = 4;

// 【確認者】確認者一覧のBoxID
export const CONFIRMER_LIST_BOX_PREFIX = "confirmer-list-box-0";

// 【承認履歴】承認者一覧のBoxID
export const APPROVAL_LIST_BOX_PREFIX = "approval-list-box-0";
